const handler = tracker => ({
  trackOpenSubmission: metadata => {
    tracker().trackEvent("Ha abierto una solicitud", metadata)
  }
})

export default handler